import React from "react";
import propTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import {
  FaBan,
  FaDatabase,
  FaExclamation,
  FaExclamationCircle,
  FaFolderOpen,
} from "react-icons/fa";
import { PathwaySvgIcn } from "svgIcon";
const PathwayComponents = ({ clicksData }) => {
  const getSubPathwayIntoPathway = (pathway) => {
    let sub_pathway = clicksData?.pathway_subcategory_data?.length
      ? clicksData.pathway_subcategory_data.filter(
          (item, i) => item.pathway_id === pathway.value
        )
      : [];
    return sub_pathway && sub_pathway.length ? (
      <ul
        className="patsub__list mt-3 mb-0 ps-1"
        style={{ maxHeight: "120px", overflow: "hidden auto" }}
      >
        {sub_pathway.map((sItem, si) => (
          <li className="text-gray position-relative" key={si}>
            {sItem.label}
          </li>
        ))}
      </ul>
    ) : (
      ""
      // <div className="empty__data py-1">
      //   <small className="opacity-25">No sub‑pathways available.</small> */}
      // </div>
    );
  };
  return (
    <div className="patsub__list">
      {clicksData?.pathway_data?.length ? (
        <Row className="g-2">
          {clicksData.pathway_data.map((item, index) => (
            <Col md={3} sm={6} xs={12} key={index}>
              <div className="patsub__box rounded">
                <h6 className="fw-bold text-dark">{item.label}</h6>
                {getSubPathwayIntoPathway(item)}
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        ""
      )}
    </div>
  );
};
PathwayComponents.propTypes = {
  history: propTypes.object,
};
export default PathwayComponents;
